
import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AccountingService } from '../accounting/accounting.service';
import { FormBuilder , FormGroup, Validators } from '@angular/forms';
import { ListService } from '../../inventory/custom/list/list.service';
import { ObjectNames } from '../../inventory/constants/constants';
import { AppMainService } from 'src/app/app-main.service';
import { ChannelN } from 'src/app/modules/shared/models/channel.model';

@Component({
  selector: 'app-pos',
  templateUrl: './pos.component.html',
  styleUrls: ['./pos.component.scss']
})
export class PosComponent implements OnInit {
  vendorCredentialsForm: FormGroup;
  vendorCode : string;
  identityCode : string;
  slectedVendorId : number;
  updatedPosConsumerId : number;
  selectedValue :any;
  selectedValues: any = {};
  posVendorInfo = [];
  products = [];
  allModules = [];
  selectedModule;
  fieldMappingListing = [];
  posConsumerId: number = 0;
  vendorName : string = "";
  posData = [];
  channelsN: ChannelN[] = []; 
  selectedChannelN:any = null;
  totalRecord: number = 0;
  pageNumber: number = 1;
  pageSize: number = 15;
  first: number = 0;
  rowsPerPage = [15, 30, 50, 100];
  product = [];
  noPosDetailsFindOrLoadingText: string = 'Loading...';
  invActiveIndex: number = 0;

  isB2BshowInstall = true;
  isB2BshowInstalled = false;
  isB2BshowDetail = false;
  showDetails : boolean = false;
  temp;
  dataView = true;
  fullInfo;
  displayMoreInfo = false;

  isEdit = false;
  isEdit2 = true;
  isField1Saved: boolean =  false;
  vendorCredentials : boolean =  false;
  fields = [];
  displayDataTB = false;
  POSheader : string = "";

  constructor(
    private confirmationService: ConfirmationService,
    private integratonService: AccountingService,
    private fb: FormBuilder,
    private messageService: MessageService,
     public appMainService: AppMainService,
     private listService: ListService,
  ) { }

  ngOnInit(): void {

    this.vendorCredentialsForm = this.fb.group({
      id: [0],
      identityCode: ['', Validators.required],
    });

    this.getAllModules();
    this.getData();
  }
  
  onTabChange(event) {
    if (event.index === 1 && !this.fieldMappingListing.length) {
      this.invActiveIndex = 1;
        this.getfieldMapping(this.vendorName,this.posConsumerId);
    } else if (event.index === 2) {
        this.getfieldMapping(this.vendorName,this.posConsumerId);
    }
}

  getfieldMapping(vendorName,posConsumerId){
    this.appMainService.isShowSpinner('fieldMappingList');
    this.integratonService.getFieldMappingListing(vendorName,posConsumerId).subscribe({
      next: (response) => {
        this.appMainService.isHideSpinner('fieldMappingList');
        this.fieldMappingListing = response;
        this.invActiveIndex = 1;
      },
      error: (error) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Something went wrong.' });
        this.appMainService.isHideSpinner('fieldMappingList');
        this.invActiveIndex = 1;
      },
      complete: () => {
        this.invActiveIndex = 1;
        this.appMainService.isHideSpinner('fieldMappingList');
      },
    });
   }

  getAllModules(){
    this.listService.getAllModules().subscribe((modules) => {
      this.allModules = modules.filter(
          (obj) =>
              obj.name == ObjectNames.productConstants.accountGroup
      );
      if (!this.selectedModule && this.allModules.length > 0) {
          this.selectedModule = this.allModules[0];
          this.getAllCustomFields();
      }
  });
  }

  getAllCustomFields(){
    this.listService.getAllCustomFields(this.selectedModule.id)
    .then((fields) => {
        this.fields = fields;
    });
  }


  getData(){

    this.appMainService.isShowSpinner('B2B');
    this.integratonService.getB2BGroups().subscribe({
      next: (response) => {
        this.products = (response);
        this.appMainService.isHideSpinner('B2B');
      },
      error: (error) => {
        this.appMainService.isHideSpinner('B2B');
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Something went wrong.' });
      },
      complete: () => {
      this.appMainService.isHideSpinner('B2B');
      }
    });
  }

  installBtn(c) {
    this.slectedVendorId = c.id;
    this.confirmationService.confirm({
      message: 'Are you sure that you want to proceed?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        const Obj = {
          posVendorId: this.slectedVendorId,
          consumerIdentifier: '',
          posConsumerId : this.updatedPosConsumerId ? this.updatedPosConsumerId : 0,
        }
        this.appMainService.isShowSpinner('installBtn');
        this.integratonService.saveB2BGroup(Obj).subscribe({
          next: (response) => {
            this.appMainService.isHideSpinner('installBtn');
            this.posConsumerId = response;
            this.posVendorFieldMapping(this.posConsumerId);
            this.messageService.add({severity: 'success',summary: 'Success',
            detail: "B2B Soft Installation completed successfully..."});
            this.isEdit = false;
            this.getData(); 
          },
          error: (error) => {
            this.appMainService.isHideSpinner('installBtn');
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Something went wrong.' });
          },
          complete: () => {
            this.appMainService.isHideSpinner('installBtn');
          }
        });
      },
    });
  }

  uninstallBtn(c) {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to proceed?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.appMainService.isShowSpinner('uninstallBtn');
        this.integratonService.uninstallB2BGroup(c.posConsumerId).subscribe({
          next: (response) => {
            this.appMainService.isHideSpinner('uninstallBtn');
            this.messageService.add({severity: 'success',summary: 'Succes',
            detail: "B2B Soft uninstallation completed successfully..."});

          },
          error: (error) => {
            this.appMainService.isHideSpinner('uninstallBtn');
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Something went wrong.' });
            
          },
          complete: () => {
          this.appMainService.isHideSpinner('uninstallBtn');
          this.getData()
          }
        });
      },
    });
  }

  changeTableView(c) {
    const id = c.posConsumerId ;
    this.vendorName = c.posVendorName
    this.isField1Saved = !!c.posConsumerId;
    if(this.isField1Saved){
      this.posConsumerId = c.posConsumerId ;
      this.posVendorFieldMapping(this.posConsumerId)
    }
    if(id){
    this.integratonService.updateB2BGroup(id).subscribe((resp )=>{
      if(resp.consumerCode || resp.consumerIdentifier){
        this.isEdit = true;
      }else{
        this.isEdit = false;
      }
      this.updatedPosConsumerId = resp.posConsumerId;
      this.vendorCredentialsForm.patchValue({
        identityCode: resp.consumerIdentifier
      });
      
    })
  }
  else{
    this.isEdit = false;
    this.vendorCredentialsForm.patchValue({
      identityCode: ''
    });
    this.updatedPosConsumerId = 0;

  }
    this.slectedVendorId = c.id;
    this.temp = JSON.parse(JSON.stringify(c));
    this.dataView = false;
  }


  showMoreInfo(c) {
    this.fullInfo = JSON.parse(JSON.stringify(c));
    this.displayMoreInfo = true;
  }

  backDataView() {
    this.dataView = true;
  }
  
  saveField1(){
    this.isEdit = true;
    this.isField1Saved = true;
  }

  isSaveDisabled(): boolean {
    return this.posVendorInfo.some(item => item.isRequired && !item.mappedCustomAttributeId);
  }

  saveVendorCredentials(e){
    const Obj = {
      posVendorId: this.slectedVendorId,
      consumerIdentifier: e.identityCode,
      posConsumerId : this.updatedPosConsumerId ? this.updatedPosConsumerId : 0,
      consumerCode: e.vendorCode
    }
    this.appMainService.isShowSpinner('installBtn');
    this.integratonService.saveB2BGroup(Obj).subscribe({
      next: (response) => {
        this.appMainService.isHideSpinner('installBtn');
        this.posConsumerId = response;
        if(!this.posConsumerId){
          this.isField1Saved = false;
          return this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Invalid vendor credentials.' });
        }
        this.posVendorFieldMapping(this.posConsumerId);
        this.messageService.add({severity: 'success',summary: 'Success',
        detail: "B2B Soft Installation completed successfully..."});
        this.isEdit = false;
        this.getData(); 
      },
      error: (error) => {
        this.appMainService.isHideSpinner('installBtn');
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Something went wrong.' });
      },
      complete: () => {
        this.appMainService.isHideSpinner('installBtn');
      }
    });
  } 

  posVendorFieldMapping(id){
    this.integratonService.posConsumerB2BGroup(id).subscribe(resp=>{
      this.posVendorInfo = (resp);
      this.isField1Saved  = !!this.posVendorInfo.length;
    })
  }

  saveField2(){
    this.isEdit2 = true;
    this.isField1Saved = true;
    
    this.posVendorInfo.forEach(item => {
      item.mappedObjectId = this.selectedModule.id;
      const field = this.fields.find(field => field.id === item.mappedCustomAttributeId);
      if (field) {
        item.mappedCustomAttributeName = field.name;
      }
   });
   this.appMainService.isShowSpinner('posFieldDropdown');
    this.integratonService.posVendorFieldMappingB2BGroup(this.posVendorInfo).subscribe({
      next: (response) => {
        this.appMainService.isHideSpinner('posFieldDropdown');
        this.messageService.add({severity: 'success',summary: 'Succes',
        detail: "Save successfully..."});
      },
      error: (error) => {
        this.appMainService.isHideSpinner('posFieldDropdown');
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Something went wrong.' });
      },
      complete: () => {
        this.appMainService.isHideSpinner('posFieldDropdown');
      }
    });
  }


posDataCount(vendorName,posConsumerId){
  this.integratonService.fieldMappingPosFields(vendorName,posConsumerId).subscribe(resp=>{
    this.posData = resp
  })
};


getListingDetails(vendorName,posConsumerId,channelId){
  this.appMainService.isShowSpinner('PosListing');
  this.integratonService.getListingDetails(vendorName,posConsumerId, channelId,this.pageNumber,this.pageSize).subscribe({
    next: (response) => {
      this.appMainService.isHideSpinner('PosListing');
         let { posVendorList, headers } = response;
        posVendorList = !posVendorList ? [] : posVendorList;
        headers = !headers  ? [] : headers;
         this.totalRecord = headers["TotalCount"];
         this.product = [];
         if (this.totalRecord > 0) {
  
        this.product = response.posVendorList.accountDetails.map(item => {
          const accountAddress = [
              item.accountAddress.address1,
              item.accountAddress.address2,
              item.accountAddress.city,
              item.accountAddress.state,
              item.accountAddress.country,
              item.accountAddress.zipCode
          ].filter(address => address !== "").join(", ");
          const newItem = {
              ...item,
              accountAddress
          };
          
          newItem.storeName = item.posStoreInfo.storeName;
          newItem.storeId = item.posStoreInfo.storeId;
          newItem.storeAddress = [item.posStoreInfo.address1,item.posStoreInfo.address2,item.posStoreInfo.city,
            item.posStoreInfo.state,
            item.posStoreInfo.zipCode].filter(address => address !== "").join(", ");

          item.posCustomFields.forEach(field => {
              newItem[field.name] = field.value;
          });
          return newItem;
      });
           this.appMainService.isHideSpinner('PosListing');
         } else {
           this.noPosDetailsFindOrLoadingText = "No Pos Found.";
           this.product = [];
           this.appMainService.isHideSpinner('PosListing');
         }
    },
    error: (error) => {
      this.appMainService.isHideSpinner('PosListing');
      return this.messageService.add({ severity: 'error', summary: 'Error', detail: `${error.error.message}` });
    },
    complete: () => {
      this.appMainService.isHideSpinner('PosListing');
    }
  });
}


  //field mapping
  showDataTB(str,channelId){
    if(str == "pos"){
      this.posDataCount(this.vendorName,this.posConsumerId);
      this.POSheader = "POS Data"
      this.displayDataTB = true;
    ;
    } else if(str == "map"){
      this.getListingDetails(this.vendorName,this.posConsumerId,channelId)
      this.POSheader = "Mapped Data";
      this.displayDataTB = true;
    } 
    // else if(str == "map"){
    //   this.POSheader = "Not Mapped Data";
    // }
  }
}
